import React from 'react';
import { projectTypes } from '../../data/site';
export function ProjectScope() {
  return <section id="projects" className="border-b border-line bg-cream" data-id="element-237" data-mp="3go4msn6lcn2k">
      <div className="mx-auto max-w-[1180px] px-5 py-20 sm:px-8 lg:py-28" data-id="element-238" data-mp="3gpzbmckzgzbx">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:gap-16" data-id="element-239" data-mp="3uop7jow2gsyp">
          <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-240" data-mp="3pmq5cic2c23c">
            <p className="micro-label text-[9px] text-gold-600" data-id="element-241" data-mp="7hwlk7w7592a">One engine, many projects</p>
            <h2 className="mt-4 font-display text-[30px] font-semibold leading-[1.1] tracking-[-0.03em] text-charcoal-700 sm:text-[36px]" data-id="element-242" data-mp="3hmgqyk54op0">
              Openings are the hardest case. They are not the only one.
            </h2>
            <p className="mt-5 text-[15px] leading-relaxed text-charcoal-500" data-id="element-243" data-mp="capnko0a63ao">
              KeyTurn was built for pre-opening, where the date cannot move and the consequences are
              unforgiving. The same intelligence engine - Health, My Turn, the meeting loop, workbook
              round trips and compounding history - runs any hotel project shaped the same way.
            </p>
            <p className="mt-4 text-[15px] leading-relaxed text-charcoal-500" data-id="element-244" data-mp="35ln35vpjgn92">
              Milestones, playbooks and departments change with the project type. What watches the
              plan does not.
            </p>
          </div>

          <ul data-id="element-245" data-mp="3ej5s3b6azlq8">
            {projectTypes.map(project => <li key={project.name} className="flex flex-col gap-1.5 border-b border-line py-5 first:border-t first:border-line sm:flex-row sm:items-baseline sm:gap-8" data-id="element-246" data-mp="3jjtv6v7t3t0t">
                <div className="flex min-w-[210px] shrink-0 items-baseline gap-3" data-id="element-247" data-mp="3tb7yle2vpcz8">
                  <h3 className="font-display text-[17px] font-semibold tracking-[-0.015em] text-charcoal-700" data-id="element-248" data-mp="15c9wjai3yy0">
                    {project.name}
                  </h3>
                  {project.core && <span className="micro-label shrink-0 text-[8px] text-gold-600" data-id="element-249" data-mp="b5bj8ieqvtbx">Core</span>}
                </div>
                <p className="text-[13.5px] leading-relaxed text-charcoal-500" data-id="element-250" data-mp="228v8lere1l50">{project.detail}</p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}